import { Size } from '@/types';
import { cn } from '@/utils';

const useModalSize = (size: Size) => {
  return cn({
    'max-w-[432px]': size === '2xs',
    'max-w-[530px]': size === 'xs',
    'max-w-screen-sm': size === 'sm',
    'max-w-screen-md': size === 'md',
    'max-w-screen-lg': size === 'lg',
    'max-w-screen-xl': size === 'xl',
    '!w-auto': size === 'auto',
  });
};

export default useModalSize;
